import React, { useEffect } from "react";
import { Button, Col, Form, InputNumber, Radio, Row, Switch, Tooltip } from "antd";
import { SettingInterface } from "src/store/community/settingsSlice";

import '../Settings.scss';
import { DollarOutlined, QuestionCircleOutlined } from "@ant-design/icons";

interface propsInterface {
  onFinish: Function;
  params?: SettingInterface['data'] | undefined;
  target:  SettingInterface['target_type'] | undefined;
}

const _Content = ({ onFinish, params, target }: propsInterface) => {
  const [form] = Form.useForm();
  const purchaseTypeValue = Form.useWatch(['content_purchase', 'purchase_type'], form);
  const rulesValue = Form.useWatch(['content_purchase', 'bundle_rules'], form);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderCreateDefaults = () => {
    if (target !== 'App') {
      return null
    }

    return (
      <>
        <h6 className="v-content-label o-sm">
          Create Defaults

          <Tooltip title="This values will be set to each post on create">
            <QuestionCircleOutlined />
          </Tooltip>
        </h6>

        <Form.Item
          label="Purchase by"
          tooltip='When ads selected, user can purchase post by watching ads or paying coins'
          name={['content_create', 'purchase_type']}
        >
          <Radio.Group>
            <Radio.Button value="free">free</Radio.Button>
            <Radio.Button value='coins'>coins</Radio.Button>
            <Radio.Button value='ads'>ads</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name={['content_create', 'coins']}
          rules={[{ required: true, message: 'Missing value' }]}
          label='Cost'
          className='v-mb-30'
        >
          <InputNumber
            min={0}
            step={5}
            placeholder='5'
            prefix={<DollarOutlined />}
          />
        </Form.Item>
      </>
    )
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      className='v-form v-settings-form'
      layout="vertical"
      autoComplete="off"
      initialValues={params}
    >
      {renderCreateDefaults()}

      <h6 className="v-content-label o-sm">Purchase settings</h6>

      <Form.Item
        label="Purchase by"
        tooltip='When ads selected, user can purchase post by watching ads or paying coins'
        name={['content_purchase', 'purchase_type']}
      >
        <Radio.Group disabled={rulesValue === false}>
          <Radio.Button value="free">free</Radio.Button>
          <Radio.Button value='coins'>coins</Radio.Button>
          <Radio.Button value='ads'>ads</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item
            name={['content_purchase', 'free_actions']}
            rules={[{ required: true, message: 'Missing value' }]}
            label='Free actions'
          >
            <InputNumber
              min={0}
              placeholder='3'
              disabled={purchaseTypeValue === 'free'}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['content_purchase', 'coins']}
            rules={[{ required: true, message: 'Missing value' }]}
            label='Cost'
          >
            <InputNumber
              min={0}
              step={5}
              placeholder='5'
              prefix={<DollarOutlined />}
              disabled={purchaseTypeValue === 'free' || rulesValue === false}
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name={['content_purchase', 'bundle_rules']}
        valuePropName='checked'
        extra='when enabled, will be used PURCHASE SETTINGS, otherwise "App" CREATE DEFAULTS settings'
        className='v-mb-30'
      >
        <Switch />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _Content;
